export const DraggedElementKind = Object.freeze({
	Booking: 'booking',
	WaitListItem: 'wait-list-item',
});
